import { Box } from "@chakra-ui/react"
import { Outlet, ScrollRestoration } from "react-router-dom"

const SpaceViewLayout = ({ space }) => {
  return (
    <Box
      id="space-view"
      className="chakra-ui-reset-css" // for integration into ./legacy
      w="full"
      h="full"
      minH="100vh"
      pos="relative"
    >
      {/* <ThemeBackground background={space.theme.background} /> */}
      <Outlet />
      {/* <BackButton /> */}
      {/* <CommandMenu /> */}
      <ScrollRestoration />
    </Box>
  )
}

export default SpaceViewLayout
